var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2335 2.53846H17.287C18.7797 2.53846 19.9501 3.82018 19.815 5.30674L19.0073 14.1914C18.8884 15.4989 17.7922 16.5 16.4793 16.5H3.34636C2.03346 16.5 0.937188 15.4989 0.818324 14.1914L0.0106316 5.30675C-0.0452852 4.69166 0.122322 4.11164 0.44379 3.64298L0.393585 2.53846C0.393585 1.13651 1.53009 0 2.93205 0H7.59212C8.26536 0 8.91103 0.267445 9.38708 0.743498L10.4385 1.79496C10.9146 2.27102 11.5603 2.53846 12.2335 2.53846ZM1.67103 2.69031C1.94112 2.59216 2.23315 2.53846 2.53867 2.53846H9.38708L8.4896 1.64098C8.25157 1.40295 7.92874 1.26923 7.59212 1.26923H2.93205C2.23907 1.26923 1.67581 1.82458 1.66304 2.5145L1.67103 2.69031Z",
    fill: "#1C2743"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoFolder);
export default __webpack_public_path__ + "static/media/ico-folder.5cc75772dd8216259c20fb65acd76168.svg";
export { ForwardRef as ReactComponent };